import React from "react";

export const DEV_STATUS_OPTIONS = [
  { key: "coming_soon", label: "Coming Soon", color: "bg-sky-50 text-sky-700 border-sky-200" },
  { key: "under_construction", label: "Under Construction", color: "bg-amber-50 text-amber-800 border-amber-200" },
  { key: "partially_complete", label: "Partially Complete", color: "bg-indigo-50 text-indigo-800 border-indigo-200" },
  { key: "completed", label: "Completed", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { key: "sold_out", label: "Sold Out", color: "bg-neutral-900 text-white border-neutral-900" },
];

export function getDevStatus(key) {
  return DEV_STATUS_OPTIONS.find((o) => o.key === key) || DEV_STATUS_OPTIONS[0];
}

export default function DevStatusBadge({ status, className = "", size = "sm" }) {
  const s = getDevStatus(status);
  const px = size === "xs" ? "px-2 py-0.5 text-[10px]" : "px-2.5 py-1 text-[11px]";
  return (
    <span
      data-testid={`dev-status-${s.key}`}
      className={`inline-flex items-center gap-1 rounded-full font-semibold border ${s.color} ${px} ${className}`}
    >
      {s.label}
    </span>
  );
}
